import {
  PERMISSION_GET_FLAGS_BEGIN,
  PERMISSION_GET_FLAGS_SUCCESS,
  PERMISSION_GET_FLAGS_FAILURE,
  PERMISSION_GET_FLAGS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function getFlags(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: PERMISSION_GET_FLAGS_BEGIN,
    });
    const { projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}permissions/get`, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: PERMISSION_GET_FLAGS_SUCCESS,
              data: res.data,
            });
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: PERMISSION_GET_FLAGS_FAILURE,
              data: { error: 'Failed' },
            });
            toast.error(`Failed: ${errMsg}`, {});
            resolve('Failed');
          }
        },
        (err) => {
          dispatch({
            type: PERMISSION_GET_FLAGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetFlagsError() {
  return {
    type: PERMISSION_GET_FLAGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERMISSION_GET_FLAGS_BEGIN:
      return {
        ...state,
        getFlagsPending: true,
        getFlagsError: null,
      };

    case PERMISSION_GET_FLAGS_SUCCESS:
      return {
        ...state,
        getFlagsPending: false,
        getFlagsError: null,
        permissionFlags: action.data,
      };

    case PERMISSION_GET_FLAGS_FAILURE:
      return {
        ...state,
        getFlagsPending: false,
        getFlagsError: action.data.error,
      };

    case PERMISSION_GET_FLAGS_DISMISS_ERROR:
      return {
        ...state,
        getFlagsError: null,
      };

    default:
      return state;
  }
}
